// Helper to safely open an HTML document in a new window for printing.
// Uses Blob URL instead of the deprecated/insecure document.write(),
// which mitigates XSS risk and avoids HTML parsing quirks.

export function printHtmlInWindow(html, { width = 400, height = 600, autoPrint = true } = {}) {
  if (!html) return null;

  const blob = new Blob(['\ufeff', html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const features = `width=${width},height=${height},menubar=no,toolbar=no,location=no,status=no`;
  const win = window.open(url, '_blank', features);

  if (!win) {
    // Pop-up blocked
    URL.revokeObjectURL(url);
    return null;
  }

  if (autoPrint) {
    const onReady = () => {
      try {
        win.focus();
        win.print();
      } catch (_e) {
        // Ignore; user can still trigger print manually.
      }
    };

    win.addEventListener('load', () => {
      // Small delay so fonts/CSS finish rendering before print dialog.
      setTimeout(onReady, 300);
    });
  }

  // Revoke blob URL after a reasonable window to prevent memory leak.
  setTimeout(() => URL.revokeObjectURL(url), 60000);

  return win;
}
